import { DealCardProps } from '~/components/deal-card'
import { ClickoutLinkType, CustomerAvailability } from '~/gql/graphql'

const today = new Date()
today.setDate(today.getDate() - 1)

const tomorrow = new Date()
tomorrow.setDate(tomorrow.getDate() + 1)

export const dummyData = (position: number) =>
  ({
    deal: {
      id: '0',
      title: 'Loading...',
      clickoutLinks: [
        {
          type: 'CLICKOUT' as ClickoutLinkType,
          url: ''
        }
      ],
      contractLength: 0,
      customerAvailability: 'NEW' as CustomerAvailability,
      directDebitLink: '',
      productId: '0',
      providerId: '0',
      termsConditionsLink: '',
      provider: {
        id: '-1',
        name: 'Loading...',
        logo: '',
        phone: [],
        adinsightCode: {
          desktop: '',
          mobile: ''
        },
        network: {
          network: 'Loading...',
          networkCodes: {
            ms3: {
              nniReference: '',
              productCode: ''
            }
          },
          status: '',
          uprn: ''
        },
        trustScores: {
          numberOfReviews: 0,
          trustpilotImageUrl: '',
          trustpilotUrl: '',
          trustScore: 0
        },
        contractTerms: {}
      },
      price: {
        monthly: [
          {
            amount: 0,
            start: 0,
            end: 0
          }
        ],
        upfront: 0,
        upfrontComponents: [],
        firstYear: 0,
        wholeContract: 0,
        advertisedMonthly: [],
        monthlyBasePrice: 0
      },
      services: {
        broadband: {
          networkName: null,
          connectionType: 'Loading...',
          estimatedDownloadTime: 0,
          title: 'Loading...',
          downloadLimit: null,
          downloadSpeed: 0,
          fibre: false,
          uploadSpeed: 0,
          maxUploadSpeed: 0
        },
        telephone: null,
        tv: null
      },
      promotions: [
        ...(position === 1
          ? [
              {
                type: 'voucher',
                id: '0',
                title: 'Usp title',
                onlineOnly: true,
                startDate: today.toISOString().toString(),
                createdAt: today.toISOString().toString(),
                endDate: tomorrow.toISOString().toString(),
                provider: '',
                titleOverriden: false,
                value: 0,
                worth: 0,
                uSwitchExclusive: true
              }
            ]
          : [])
      ],
      priceBreakdown: [],
      features: [],
      terms: []
    },
    tenancy: {},
    list: '',
    position,
    placementType: '',
    href: '',
    onClick: () => {},
    isSponsored: position === 1
  } as DealCardProps)
